/**
 * load-algorithm-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * The client sends a {@link LoadAlgorithmRequest} to request dynamic loading of
 * a particular algorithm. The algorithm is specified by name. The response is
 * an {@link AcknowledgmentResponse} that describes the outcome.
 */
export class LoadAlgorithmRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_LOAD_ALGORITHM;
	public static tag : MessageTag = MessageTag.REQ_LOAD_ALGORITHM;

  /**
   * Construct a new {@link LoadAlgorithmRequest}.
   *
   * @param name
   *        The name of the target algorithm.
   */
  constructor (public name : string)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/load-algorithm-request.ts